/**
 * Whiteboard rollout gate. The feature is only surfaced (nav link + routes) for
 * the organizations listed here; everyone else is bounced to "/" and never sees
 * the link. Extend the set to widen the rollout. The mock harness adds its own
 * fictional org at boot so the in-browser demo keeps working.
 */
export const WHITEBOARD_ORGANIZATION_IDS = new Set<string>([
    '019f80b4-1ca7-7000-976b-0fcfd35b42a1', // River Road Veterinary Hospital
    '018ee238-891a-7001-aab7-dc931c2b0fe2', // Tal Test Clinic
    '0185644d-9383-7000-b35d-6e31e1158b43', // NerveX Admin
]);

export const isWhiteboardEnabledFor = (organizationId: string | null | undefined): boolean =>
    !!organizationId && WHITEBOARD_ORGANIZATION_IDS.has(organizationId.toLowerCase());
